import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { safeStorageAdapter } from '@/lib/safeStorage';

// Single source of truth for the Supabase project URL/anon key.
// Fail-fast at module load if env is missing — never silently fall back to a
// hardcoded URL (Lovable AI added those; CLAUDE.md SoT rule forbids it).
const envUrl = import.meta.env.VITE_SUPABASE_URL;
const envKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
if (!envUrl) throw new Error('VITE_SUPABASE_URL is not set. Configure it via Doppler / Cloudflare Pages env.');
if (!envKey) throw new Error('VITE_SUPABASE_PUBLISHABLE_KEY is not set. Configure it via Doppler / Cloudflare Pages env.');

export const SUPABASE_URL = envUrl;
export const SUPABASE_PUBLISHABLE_KEY = envKey;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: safeStorageAdapter,
    persistSession: true,
    autoRefreshToken: true,
  }
});